import remoteApi from "common/remote/api";
import { SearchEmptyRoomResponse } from "./search.model";

export const onSearch = (criterias: object): Promise<SearchEmptyRoomResponse> =>
	remoteApi.get("/room/empty/", {
		params: {
			...criterias,
		},
	});
